module.exports = __webpack_public_path__ + "img/logo-admin.84425c3b.png";